var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.074 2.694a1.725 1.725 0 0 0-2.435.05l-6.863 7.23a.18.18 0 0 0-.048.107l-.274 3.182a.185.185 0 0 0 .218.195l3.303-.534a.19.19 0 0 0 .105-.053l6.928-7.008a1.6 1.6 0 0 0-.025-2.288l-.909-.88Zm-3.263-.689C10.894.865 12.74.827 13.87 1.923l.909.881a2.666 2.666 0 0 1 .041 3.814l-6.928 7.007c-.196.198-.453.33-.732.375l-3.303.533c-.844.137-1.595-.534-1.524-1.36l.273-3.182c.025-.282.145-.548.342-.756l6.863-7.23Z",
    fill: "#5C5B69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.788 6.915c-.798-.722-1.323-1.65-1.53-2.853l1.11-.18c.168.978.58 1.686 1.188 2.236.62.561 1.473.984 2.56 1.335l-.356 1.035c-1.163-.376-2.186-.862-2.972-1.573ZM1.5 16.33c0-.3.252-.545.563-.545h13.5c.31 0 .562.244.562.545a.554.554 0 0 1-.563.546h-13.5a.554.554 0 0 1-.562-.546Z",
    fill: "#5C5B69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dca19bffe9d4cfadd850ee9fd7639aed.svg";
export { ForwardRef as ReactComponent };